import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  CHECK_MEDI_CAL_BENEFIT_RESTRICT_REQUEST: '',
  CHECK_MEDI_CAL_BENEFIT_RESTRICT_SUCCESS: '',
  CHECK_MEDI_CAL_BENEFIT_RESTRICT_FAILURE: '',

  CHECK_MEDI_CAL_CODE_REQUEST: '',
  CHECK_MEDI_CAL_CODE_SUCCESS: '',
  CHECK_MEDI_CAL_CODE_FAILURE: '',
};

types = setStoreTypeValues(types, 'authMediCal');

export default types;
